export interface AppConfig {
  apiUrl: string
  keycloakUrl: string
  keycloakRealm: string
  keycloakClientId: string
}

// Configuration d'exécution : montée sur /config.json par vps-stack en prod,
// servie depuis public/config.json en dev.
// Top-level await : tout module qui l'importe attend son chargement.
// no-cache : revalidée à chaque chargement (nginx l'envoie en no-store). Pas no-store ici : Firefox hors ligne ne passe
// alors pas la requête au service worker, qui en sert la copie
const response = await fetch('/config.json', { cache: 'no-cache' })
if (!response.ok) {
  throw new Error(`Impossible de charger /config.json (HTTP ${response.status})`)
}

export const config: AppConfig = await response.json()
